import { DataTable, DeleteDialog, Heading, Loader } from "@/components";
import { Input } from "@/components/ui";
import { Search } from "lucide-react";
import useCommunities from "./useCommunities";

const Communities = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    communitiesData,
    isLoadingCommunities,
    onClose,
    openDialog,
    onConfirm,
    isDeletePending,
    communityDeleteState,
    isLoadingCommunityDeleteState,
    deletedRow,
    onRowClick,
  } = useCommunities();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="All Communities" />
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingCommunities ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={[...(communitiesData?.data || [])]
              .sort((a, b) => {
                return a.communityId - b.communityId;
              })
              .reverse()}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
          />
          <DeleteDialog
            open={openDialog}
            onClose={onClose}
            onConfirm={onConfirm}
            isLoading={isDeletePending}
            contents={[
              <div>
                {`Deleting `}
                <b className="text-primary">{deletedRow?.name}</b>
                {` community will permanently remove all related data. This action cannot be undone. Do you want to proceed?`}
              </div>,
              <div>
                <div>
                  {`Deleting `}
                  <b className="text-primary">{deletedRow?.name}</b>
                  {` community will permanently remove all related data. This action cannot be undone. Do you want to proceed? Below are items affected:`}
                </div>
                {isLoadingCommunityDeleteState ? (
                  <Loader />
                ) : (
                  <div className="flex flex-col gap-1 mt-2">
                    <span>
                      <i className="text-primary">Number of properties : </i>
                      {communityDeleteState?.data?.propertyCount || 0}
                    </span>
                    <span>
                      <i className="text-primary">Number of Users : </i>
                      {communityDeleteState?.data?.userCount || 0}
                    </span>
                    <span>
                      <i className="text-primary">
                        Number of financial Records :
                      </i>{" "}
                      {communityDeleteState?.data?.financialRecordCount || 0}
                    </span>
                  </div>
                )}
              </div>,
            ]}
          />
        </>
      )}
    </div>
  );
};

export default Communities;
